module.exports = __webpack_public_path__ + "static/img/backupRestoreIcon.cbe0e05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/backupRestoreIcon.svg
// module id = Ra4w
// module chunks = 0